module.exports = __webpack_public_path__ + "img/nine_ten.d70bcd45.svg";